<template>
  <div class="logo">
    <div class="logo__bar logo__bar--1" />
    <div class="logo__bar logo__bar--2" />
    <div class="logo__bar logo__bar--3">
      <div class="logo__dot" />
    </div>
  </div>
</template>

<style scoped>
.logo__bar {
  display: inline-block;
  width: .625rem;
  width: .625rem;
  border-radius: .625rem;
  margin: 0 .125rem;
  @apply bg-gray-500;
  @apply shadow;
}

.logo__bar--1 {
  height: 1.25rem;
}

.logo__bar--2 {
  height: 1.75rem;
}

.logo__bar--3 {
  height: 2.25rem;
  position: relative;
}

.logo__dot {
  position: absolute;
  top: .1rem;
  left: 50%;
  transform: translateX(-50%);
  width: .4375rem;
  height: .4375rem;
  border-radius: 50%;
  box-shadow: inset 0 .025rem 2px rgba(0, 0, 0, .35);
  @apply bg-orange;
}

.dark .logo__bar {
  @apply bg-gray-300;
}
</style>
